var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEye = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: 22,
    height: 22,
    x: 0,
    y: 0,
    viewBox: "0 0 409.6 409.6",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.8,68.265C117.233,68.265,40.965,123.264,0,204.8c40.965,81.551,117.233,136.535,204.8,136.535 S368.635,286.351,409.6,204.8C368.635,123.264,292.367,68.265,204.8,68.265z M204.8,290.135c-47.135,0-85.335-38.2-85.335-85.335 s38.2-85.335,85.335-85.335s85.335,38.2,85.335,85.335S251.935,290.135,204.8,290.135z",
    fill: "#16191f",
    "data-original": "#16191f",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 204.8,
    cy: 204.8,
    r: 51.2,
    fill: "#16191f",
    "data-original": "#16191f",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye.0acd1c2b.svg";
export { ForwardRef as ReactComponent };